import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import React from 'react';
import { Outlet } from 'react-router-dom';

import { HelpDrawerProvider, useHelpDrawer } from '../../context/HelpDrawerContext';
import { UpgradePromptProvider } from '../../context/UpgradePromptContext';
import GlobalHelpButton from '../helpCenter/GlobalHelpButton';
import HelpCenterDrawer from '../helpCenter/HelpCenterDrawer';
import LicenseDenialInterceptorSetup from '../licensing/LicenseDenialInterceptorSetup';

/**
 * HelpDrawerComponents - Renders the global Help Center FAB and drawer
 * Must be inside HelpDrawerProvider to access context
 */
const HelpDrawerComponents: React.FC = () => {
  const { isOpen, close } = useHelpDrawer();

  return (
    <>
      <GlobalHelpButton />
      <HelpCenterDrawer open={isOpen} onClose={close} />
    </>
  );
};

/**
 * RootLayout wraps all routes with providers that need router context.
 * This is rendered INSIDE the RouterProvider, so these providers
 * can safely use react-router hooks like useNavigate, Link, etc.
 */
const RootLayout: React.FC = () => {
  return (
    <HelpDrawerProvider>
      <UpgradePromptProvider>
        <LicenseDenialInterceptorSetup />
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Outlet />
          <HelpDrawerComponents />
        </LocalizationProvider>
      </UpgradePromptProvider>
    </HelpDrawerProvider>
  );
};

export default RootLayout;
